@if (isLoading()) {
  <kendo-loader
    [type]="'infinite-spinner'"
    [size]="'large'"
  ></kendo-loader>
} @else if (ticketsByEventName().length > 0) {
  <div>
    <input
      type="checkbox"
      size="large"
      rounded="large"
      kendoCheckBox
      checked
      #caseFilterCheckbox
      [(ngModel)]="checked"
      (ngModelChange)="caseFilter()"
    />
    <kendo-label
      [for]="caseFilterCheckbox"
      text="Show Only Escalated Cases"
    ></kendo-label>
  </div>
  <kendo-chart (render)="popupService.attachSurfaceHandlers($event, popupTemplate)">
    <kendo-chart-tooltip> </kendo-chart-tooltip>
    <kendo-chart-series>
      <kendo-chart-series-item
        type="line"
        [style]="'smooth'"
        [data]="ticketsByEventName()"
        [color]="getColor"
        field="count"
        categoryField="description"
      >
      </kendo-chart-series-item>
    </kendo-chart-series>
    <kendo-chart-category-axis>
      <kendo-chart-category-axis-item>
        <kendo-chart-category-axis-item-labels
          [content]="truncateCategoryLabel"
          rotation="auto"
        ></kendo-chart-category-axis-item-labels>
      </kendo-chart-category-axis-item>
    </kendo-chart-category-axis>
  </kendo-chart>

  <ng-template #popupTemplate>
    <div class="chart-popup k-tooltip">
      {{ popupService.popupContent }}
    </div>
  </ng-template>

  <kendo-dialog
    *ngIf="showPopup"
    (close)="close()"
  >
    <kendo-dialog-titlebar>View Data</kendo-dialog-titlebar>
    <kendo-grid
      class="mxh-80v"
      [filterable]="true"
      [data]="gridService | async"
      [pageable]="{
        buttonCount: 5,
        info: true,
        type: 'numeric',
        pageSizes: [25, 50, 100, 200]
      }"
      [pageSize]="gridService.state.take"
      [skip]="gridService.state.skip"
      [(filter)]="gridService.state.filter"
      [loading]="gridService.loading"
      (dataStateChange)="gridService.onStateChange($event)"
      [sort]="this.gridService.state.sort"
      [sortable]="true"
    >
      <ng-template kendoGridToolbarTemplate>
        <button
          type="button"
          kendoGridExcelCommand
          class="cyflare-btn-secondary"
        >
          Export to Excel
        </button>
      </ng-template>
      <kendo-grid-column
        [filterable]="false"
        field="alert_received_on"
        title="Received On"
      ></kendo-grid-column>
      <kendo-grid-column
        field="closure_reason"
        title="Closure Reason"
      ></kendo-grid-column>
      <kendo-grid-column
        field="event_name"
        title="Name"
      ></kendo-grid-column>
      <kendo-grid-column
        field="case_severity"
        title="Case Severity"
      ></kendo-grid-column>
      <kendo-grid-column
        field="case_source"
        title="Case Source"
      ></kendo-grid-column>
      <kendo-grid-excel
        fileName="top-detections-data.xlsx"
        [fetchData]="allData"
      ></kendo-grid-excel>
    </kendo-grid>
  </kendo-dialog>
} @else {
  <h1>No Data</h1>
}
